import { Stack } from 'expo-router';

import { useMenuTabStackOptions } from '../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export default function MenuTabLayout() {
  const options = useMenuTabStackOptions();

  return (
    <Stack screenOptions={options.Stack} initialRouteName="menu/index">
      <Stack.Screen name="menu/index" />
      <Stack.Screen name="locations/index" options={options.Locations} />
    </Stack>
  );
}
